<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-container>
            <div v-if="tipoSolicitud === 'bono-adicional'">
                <v-row>
                    <v-col cols="12">
                        <v-label class="my-text-black mt-4">Número de autorización</v-label>
                        <v-text-field
                            v-model="solicitud.nroAutorizacion"
                            label="Número de autorización"
                            justify-end
                            outlined
                            variant="solo"
                            clearable
                            required
                            :rules="obligatorioAlfanumericoSinCero"
                            class="asterisco"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-divider id="divider"></v-divider>
            </div>
        
            <EfectorSelect
                @profesional-seleccionado="profesionalSeleccionado"
                ref="efectorSelect"
            ></EfectorSelect>
            <EspecialidadOptions
                ref="especialidadOptions"
                :obligatorio="obligatorio"
                :idProfesional="profesionalEfector ? profesionalEfector.id : null"
                @especialidadSeleccionada="onEspecialidadChange($event)"
            ></EspecialidadOptions>
            <v-divider id="divider"></v-divider>
            <v-row>
                <v-col cols="12">
                    <v-label class="my-text-black mt-4 text-h5">Cargue archivo de {{this.tipoSolicitud == 'bono-adicional' ? 'autorización' : 'orden y planilla alta complejidad'}} <p style="color: red;">*</p></v-label>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" class="mb-4">
                    <ModalArchivosConTipo
                        @agregarArchivos="agregarArchivos"
                        :autorizacionObligatoria="tipoSolicitud == 'bono-adicional' ? true : false"
                        :ordenYAltaComplejidadObligatoria="tipoSolicitud == 'practica-pesada' ? true : false"
                        :tiposDocumentacion="tiposDocumentacion"
                        :archivosActuales="solicitud.files"
                    ></ModalArchivosConTipo>
                </v-col>
                <v-col cols="12" md="12">
                    <!-- <v-chip-group>
                        <v-chip v-for="file in solicitud.files" :key="file.nombre">{{this.tipoDocumentacion(file.tipoDocumentacion) +''+ file.nombre }}</v-chip>
                    </v-chip-group> -->
                    <ImageTable
                        v-if="this.solicitud.files && this.solicitud.files.length > 0"
                        :files="this.solicitud.files"
                        :headers="[
                            { title: 'Documentación', key: 'tipoDocumentacion'},
                            { title: 'Nombre', key: 'nombre' },
                            { title: 'Tipo', key: 'tipoMime' },
                            { title: 'Acciones', key: 'contenidoBase64' }
                        ]"
                        :tiposDocumentacion="tiposDocumentacion"
                        :mostrarEliminar="true"
                        :mostrarNewTab="false"
                        :mostrarDownload="false"
                        @eliminar-archivo="eliminarArchivo"
                    >  
                    </ImageTable>
                </v-col>
            </v-row>
            <v-divider id="divider"></v-divider>
            <label class="my-text-black mt-4">Gasto asignado al:</label>
            <v-radio-group
            v-model="solicitud.gastos"
            inline
            >
            <v-radio
                label="Prestador"
                value="prestador"
                checked
            ></v-radio>
            <v-radio
                label="Profesional"
                value="profesional"
            ></v-radio>
            </v-radio-group>

            <v-divider id="divider"></v-divider>
        </v-container>
        <v-container>
            <v-row class="ml-1" v-if="tipoSolicitud=='practica-pesada' && aceptaUrgencia()">
                <v-switch 
                    v-model="solicitud.esUrgente"
                    inset
                    color="red-darken-4"
                    base-color="grey lighten-4"
                    class="my-text-black"
                >
                <template v-slot:label>
                    <p class="my-text-black" style="color: black;">{{solicitud.esUrgente ? 'Urgente' : 'No Urgente'}}</p>
                </template>
            </v-switch>
            </v-row>
            <v-row v-if="solicitud.esUrgente">
                <v-col cols="12" md="4">
                    <v-text-field 
                        label="CUC" 
                        variant="solo"
                        v-model="solicitud.cucUrgencia"
                        type="text"
                        class="asterisco"
                        :rules="solicitud.esUrgente ? obligatorio : ''"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                    <v-text-field 
                        label="Motivo de la urgencia"
                        variant="solo"
                        v-model="solicitud.motivoUrgencia"
                        type="text"
                        class="asterisco"
                        :rules="solicitud.esUrgente ? obligatorio : ''"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <div v-if="efectorSeleccionado">
                <v-label class="my-text-black">Añada la prestación {{ tipoSolicitud == 'bono-adicional' ? "del bono adicional" : "de la práctica pesada" }}</v-label>
                <v-row align="center">
                    <v-col cols="12" md="8">
                        <PrestacionSelect
                            ref="prestacionSelect"
                            @prestacion-seleccionada="this.prestacion.prestacion = $event"
                            :tipoSolicitud="tipoSolicitud"
                        ></PrestacionSelect>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field 
                            label="Cantidad" 
                            variant="solo"
                            v-model="prestacion.cantidad"
                            type="number"
                            :rules="opcionalNumerico"
                            class="asterisco"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-center">
                        <v-btn 
                        @click="agregarPrestacion()" 
                        block 
                        class="py-7 mb-5" 
                        id="boton-verde" 
                        :disabled="errorCargaBono()"
                        :loading="agregandoPrestacion"
                        >
                            Añadir
                        </v-btn>
                    </v-col>
                </v-row>
                <ItemPrestacion 
                    v-if="this.solicitud.prestaciones.length > 0"
                    @eliminar-prestacion="eliminarPrestacion($event)"
                    :listadoPrestaciones="prestacionesAgregadas"
                    :obligatorio="obligatorio"
                    :mostrarDiagnostico="esBonoDePractica"
                    :tiposDocumentacion="tiposDocumentacion"
                    :mostrarCargaArchivos="false"
                    :diagnosticos="[]"
                    :copagoObligatorio="this.copagoObligatorio()"
                    @actualizar-copago-solicitud="actualizarCopagoSolicitud"
                ></ItemPrestacion>
                <v-label class="my-text-black mt-4">Copago total</v-label>
                    <v-text-field
                        readonly
                        v-model="solicitud.copago"
                        variant="solo"
                        prepend-inner-icon="mdi mdi-currency-usd"
                    >
                </v-text-field>
                <PrescriptorForm
                    v-if="esBonoDePractica"
                    @actualizar-profesion="this.solicitud.ProfesionPrescriptor = $event.profesion.idIOMA;"
                    @actualizar-prescriptor="this.solicitud.TipoMatriculaPrescriptor = $event.tipoMatricula; this.solicitud.matriculaprescriptor = $event.matriculaPrescriptor; this.solicitud.nombreApellidoPrescriptor = $event.nombreApellidoPrescriptor"
                ></PrescriptorForm>
            </div>
            <v-btn class="mt-4" id="boton-verde" type="submit" block :disabled="cargando || !valid || solicitud.prestaciones.length == 0 || agregandoPrestacion == true" :loading="agregandoPrestacion == true || cargando" >{{this.tipoSolicitud == 'bono-adicional' ? 'Autorizar' : 'Cargar'}}</v-btn>
        </v-container>
    </v-form>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="cerrarModal"
    />
</template>
<style src="../assets/general.css"></style>
<script>
    import EfectorSelect from './EfectorSelect.vue';
    import ItemPrestacion from './ItemPrestacion.vue';
    import PrestacionSelect from './PrestacionSelect.vue';
    import EspecialidadOptions from './EspecialidadOptions.vue';
    import ModalArchivosConTipo from './ModalArchivosConTipo.vue';
    import GeneralService from '@/api/GeneralService';
    import PrescriptorForm from './PrescriptorForm.vue';
    import PrestacionService from '@/api/PrestacionService';
    import AlertComponent from './AlertComponent.vue';
    import { obligatorio, opcionalAlfaNumerico } from '@/_helpers/rules';
    import ImageTable from './ImageTable.vue';

    const generalService = new GeneralService();
    const prestacionService = new PrestacionService();

    export default {
        components: {
            EfectorSelect,
            ItemPrestacion,
            PrestacionSelect,
            EspecialidadOptions,
            ModalArchivosConTipo,
            PrescriptorForm,
            AlertComponent,
            ImageTable
        },
        props: {
            tipoSolicitud: {
                type: String,
                required: true,
            },
        },
        data(){
            return {
                solicitud: {
                    nroAutorizacion: null,
                    copago: null,
                    efectorId: null,
                    idEspecialidad: null,
                    gastos: 'prestador',
                    matriculaprescriptor: null,
                    nombreApellidoPrescriptor: null,
                    TipoMatriculaPrescriptor: null,
                    ProfesionPrescriptor: null,
                    tipoIngreso: null,
                    prestaciones: [],
                    username: null,
                    validacionId: null,
                    files: [],
                    cucUrgencia: null,
                    motivoUrgencia: null,
                    esUrgente: false,
                },
                efectorSeleccionado: false,
                valid: false,
                prestaciones: [],
                prestacion: {
                    prestacion: null,
                    cantidad: null,
                },
                tiposDocumentacion: [],
                agregandoPrestacion: false,
                cargandoPrestaciones: false,
                cargando: false,
                obligatorio: obligatorio,
                profesionalEfector: null,
                esPractica: false,
                showAlert: false,
                alertTitle: "",
                alertText: "",
                alertType: ""
            }
        },
        computed: {
            esBonoDePractica(){
                if(this.solicitud.prestaciones.length > 0){
                    return this.solicitud.prestaciones[0].Codigo != '420101';
                }
                return false;
            },
            prestacionesAgregadas(){
                return this.solicitud.prestaciones;
            },
        },
        async mounted(){
            await this.getTiposDocumentacion();
            await this.cargarProfEfector();
        },
        methods: {
            async handleSubmit(){
                if(this.valid && !this.cargando){
                    this.cargando = true;
                    const tieneArch = this.tipoSolicitud == 'bono-adicional' ? 
                        this.checkearArchivosObligatorios(4) : 
                        (this.checkearArchivosObligatorios(0) && this.checkearArchivosObligatorios(5));

                    if(tieneArch.length == 0){
                        this.alertTitle= "Solicitud no creada";
                        this.alertText= "Debe cargar al menos un archivo de " + (this.tipoSolicitud == 'bono-adicional' ? 'autorización' : 'orden y planilla alta complejidad');
                        this.alertType="error";
                        this.showAlert= true;
                        this.cargando = false;
                        return;
                    }
                    this.armarSolicitud();
                    const response = this.tipoSolicitud == 'bono-adicional' ?
                        await prestacionService.postBonoAdicional(this.solicitud) :
                        await prestacionService.postPracticaPesada(this.solicitud);

                    if(response.status === 200){
                        this.alertTitle= "Solicitud creada" + (this.tipoSolicitud == 'bono-adicional' ? " y autorizada" : "");
                        this.alertText= "Podrá visualizarla en el listado de solicitudes" + (this.tipoSolicitud == 'bono-adicional' ? "Número de autorización: " + this.solicitud.nroAutorizacion : "") + (response.data.mensaje ? response.data.mensaje : "");
                        this.alertType="success";
                        this.reiniciarEstado();
                    } else {
                        this.alertTitle= "Error al crear la solicitud";
                        this.alertText= response.data;
                        this.alertType="error";
                    }
                    this.cargando = false;
                    this.showAlert= true;
                }
            },
            async cargarProfEfector(){
                const profesionalFacturador = this.$store.getters.getProfesional;
                if(profesionalFacturador.matriculaProvincial != null){
                    this.profesionalSeleccionado(profesionalFacturador);
                    this.$refs.efectorSelect.setearProfesional(profesionalFacturador);
                } else{
                    const profesionalLogeado = this.$store.getters.getProfesionalUsuario;
                    if(profesionalLogeado){
                        this.profesionalSeleccionado(profesionalLogeado);
                        this.$refs.efectorSelect.setearProfesional(profesionalLogeado);
                    } else {
                        this.profesionalEfector = null;
                    }
                }
            },
            armarSolicitud(){
                this.solicitud.username = this.$store.getters.getUsername;
                this.solicitud.idFacturador = this.$store.getters.getFacturador.id;
                this.solicitud.validacionId = this.$store.getters.getPaciente.idValidacion;
                this.solicitud.tipoIngreso = this.$store.getters.getIngreso.valor;
                this.solicitud.copago = this.solicitud.prestaciones[0].Copago ? this.solicitud.prestaciones[0].Copago : 0;
            },
            actualizarCopagoSolicitud(){
                if(this.solicitud.prestaciones.length === 0){
                    this.solicitud.copago = 0;
                    return;
                }
                this.solicitud.copago = this.solicitud.prestaciones.map(p => {
                    let copago = p.Copago ? parseFloat(p.Copago) : 0;
                    return copago*p.Cantidad;
                }).reduce((a, b) => a + b, 0);
            },
            async agregarPrestacion(){
                this.agregandoPrestacion = true;
                let copago = await this.getCopagoPractica(this.prestacion.prestacion.id);
                // if (copago == 0){
                //     copago = null;
                // }
                let nuevaPrest = {
                    Descripcion: this.prestacion.prestacion.descripcion,
                    Codigo: this.prestacion.prestacion.codigo,
                    Cantidad: this.prestacion.cantidad,
                    Operacion: 'Quitar',
                    Copago: copago, // Acá se rompe si es 0 por un tema de actualizar los valores al ser 0 :(
                }
                let posExiste = -1;
                posExiste = this.practicaYaCargada(nuevaPrest);
                if(posExiste != -1){
                    this.solicitud.prestaciones[posExiste].Cantidad = (
                        parseInt(this.solicitud.prestaciones[posExiste].Cantidad, 10) + 
                        parseInt(nuevaPrest.Cantidad, 10)
                    ).toString();
                } else{
                    this.solicitud.prestaciones.push(nuevaPrest);
                }
                this.actualizarCopagoSolicitud();
                this.prestacion = {
                    cantidad: null,
                };
                this.agregandoPrestacion = false;
            },
            eliminarPrestacion(codigo){
                this.solicitud.prestaciones = this.solicitud.prestaciones.filter(prestacion => prestacion.Codigo !== codigo);
                this.actualizarCopagoSolicitud();
            },
            practicaYaCargada(nuevaPrest){
                return this.solicitud.prestaciones.findIndex(p => p.Codigo === nuevaPrest.Codigo && p.Descripcion.toUpperCase() === nuevaPrest.Descripcion.toUpperCase());
            },
            async getTiposDocumentacion(){
                await generalService.GetTiposDocumentacion()
                    .then(response => {
                        this.tiposDocumentacion = response.data; //nombe, valor
                        if(this.tipoSolicitud == 'bono-adicional'){
                            this.tiposDocumentacion = this.tiposDocumentacion.filter(tipo => tipo.valor != 3 && tipo.valor != 5);
                        } else {
                            this.tiposDocumentacion = this.tiposDocumentacion.filter(tipo => tipo.valor != 3 && tipo.valor != 4);
                        }
                    }) 
                    .catch(error => {
                        console.log(error);
                    });
            },
            async getCopagoPractica(idPractica){
                const obraSocialId = this.$store.getters.getObraSocial.id;
                const response = await prestacionService.getCopagoPractica(obraSocialId, idPractica);
                if(response && response.status == 200){
                    return response.data;
                }
                else{
                    return null;
                }
            },
            errorCargaBono(){
                return this.prestacion == null || 
                this.prestacion.prestacion == null ||
                this.prestacion.cantidad == null ||
                this.prestacion.cantidad == 0 ||
                this.prestacion.cantidad > 9 ||
                this.solicitud.prestaciones.length == 1 && this.solicitud.prestaciones[0].Codigo != this.prestacion.prestacion.codigo ||
                this.solicitud.prestaciones.length == 1 && this.solicitud.prestaciones[0].Codigo == this.prestacion.prestacion.codigo && 
                parseInt(this.solicitud.prestaciones[0].Cantidad,10) + parseInt(this.prestacion.cantidad) > 9;
            },
            checkearArchivosObligatorios(tipoDoc){
                return this.solicitud.files.filter(file => file.tipoDocumentacion == tipoDoc)
            },
            async profesionalSeleccionado(profesional){
                if(profesional){
                    this.profesionalEfector = profesional;
                    this.solicitud.efectorId = profesional.id;
                }
                this.onProfesionalChange();
            },
            onProfesionalChange(){
                if(this.profesionalEfector){
                    this.$refs.especialidadOptions.getEspecialidadesProfesional(this.profesionalEfector.id)
                }
            },
            tipoDocumentacion(valor){
                const tipo = this.tiposDocumentacion.find(tipo => tipo.valor === valor);
                return tipo ? `${tipo.nombre}-` : "";
            },
            copagoObligatorio(){
                return this.$store.getters.getConfiguracionesOS.ingresoCopagoObligatorio;
            },
            reiniciarEstado(){
                this.solicitud = {
                    nroAutorizacion: null,
                    copago: null,
                    efectorId: null,
                    idEspecialidad: null,
                    gastos: 'prestador',
                    matriculaprescriptor: null,
                    nombreApellidoPrescriptor: null,
                    tipoIngreso: null,
                    prestaciones: [],
                    username: null,
                    validacionId: null,
                    files: [],
                };
                this.prestacion = {
                    prestacion: null,
                    cantidad: null,
                };
                this.profesionalEfector = null;
                this.esPractica = false;
            },
            esPorConfianza(){
                return this.$store.getters.getPedirDatosPaciente;
            },
            cerrarModal(){
                this.showAlert = false;
                if(this.alertType === 'success'){
                    if(this.esPorConfianza()){
                        this.$router.push('elegibilidad');
                    } else {
                        this.$emit('cerrar-bono-adicional');
                    }
                }
            },
            async onEspecialidadChange(especialidad){
                if(especialidad){
                    this.efectorSeleccionado = true;
                    this.solicitud.idEspecialidad = especialidad.id;
                    this.$store.commit('setIdProfesion', especialidad.idProfesion)
                    if(this.$refs.prestacionSelect){
                        await this.$refs.prestacionSelect.cargarPrestaciones();
                    }
                }
                else{
                    this.efectorSeleccionado = false;
                    this.solicitud.idEspecialidad = null;
                    this.$store.commit('setIdProfesion', null)
                }
            },
            aceptaUrgencia(){
                return this.$store.getters.getConfiguracionesOS.aceptaUrgencia;
            },
            //metodos para manejar archivos
            agregarArchivos(archivos){
                this.solicitud.files.push(...archivos);
            },
            eliminarArchivo({dominio,idArchivo, idSolicitudPractica}) {
                this.solicitud.files = this.solicitud.files.filter(file => file.id !== idArchivo);
            },
        },
    }
</script>